import type { PermissionChipProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/CallsTab/CallsTransferStatus/PermissionChip/index.types';
import { TONE } from 'Modules/softphone/components/SoftphoneDevTools/styles';
import React from 'react';
import { cn } from '~/lib/utils';

/** Whether an action is available, named as the store names it. */
export const PermissionChip: React.FC<PermissionChipProps> = ({
  label,
  allowed,
}) => {
  const tone = allowed ? TONE.ok : TONE.muted;

  return (
    <span
      className={cn(
        'flex flex-1 items-center gap-1.5 px-2 py-[5px] text-[11px] font-medium',
        tone.inset,
        tone.text
      )}
    >
      {allowed ? '✓' : '✕'}
      <span className="font-sp-mono">{label}</span>
    </span>
  );
};
